'use client'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useState } from 'react'

import { createQueryClient } from '../helpers/reactQuery'
import type { ReactNode } from 'react'

export interface ReactQueryClientProviderProps {
  children: ReactNode
}

export const ReactQueryClientProvider = ({
  children,
}: ReactQueryClientProviderProps) => {
  const [queryClient] = useState(() => createQueryClient())

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools />
    </QueryClientProvider>
  )
}
